import { render, staticRenderFns } from "./EventRepliesModal.vue?vue&type=template&id=3741fefb&lang=pug"
import script from "./EventRepliesModal.vue?vue&type=script&lang=ts"
export * from "./EventRepliesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports